import React from 'react';
import { Checkbox, Text, TextButton } from '@wix/design-system';
import { HELP_LINKS } from '../constants/helpLinks';
import { getDeleteModalTitle } from './getDeleteModalTitle';
export const getDeleteModalOptions = _ref => {
  let {
    isSiteFilesEntry,
    isConfirmChecked,
    toggleConfirmCheckbox,
    selectedItemsCount,
    formatMessage,
    deleteFiles,
    closeModal,
    onAfterClose
  } = _ref;
  return {
    showHeaderDivider: false,
    showFooterDivider: false,
    title: getDeleteModalTitle(formatMessage, isSiteFilesEntry, selectedItemsCount),
    primaryButtonProps: {
      skin: 'destructive'
    },
    secondaryButtonProps: {
      skin: 'standard'
    },
    width: '510px',
    content: /*#__PURE__*/React.createElement(Text, null, formatMessage({
      id: 'files-manager.delete-permanently-modal-warning.text'
    }, {
      itemsCount: selectedItemsCount
    }), "\xA0", /*#__PURE__*/React.createElement(TextButton, {
      as: "a",
      target: "_blank",
      href: HELP_LINKS.DELETE_MODAL,
      dataHook: "file-awareness-delete-modal-learn-more"
    }, formatMessage({
      id: 'files-manager.delete-permanently-modal-warning.link'
    }))),
    confirmText: formatMessage({
      id: 'files-manager.delete-permanently-modal-warning.primary-cta'
    }, {
      itemsCount: selectedItemsCount
    }),
    cancelText: formatMessage({
      id: 'files-manager.delete-permanently-modal-warning.secondary-cta'
    }),
    disableConfirmation: !isConfirmChecked,
    sideActions: /*#__PURE__*/React.createElement(Checkbox, {
      checked: isConfirmChecked,
      onChange: toggleConfirmCheckbox,
      dataHook: "checkbox-confirm-delete-permanently"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "thin"
    }, formatMessage({
      id: 'files-manager.delete-permanently-modal-warning.confirm-checkbox'
    }, {
      itemsCount: selectedItemsCount
    }))),
    onCancel: () => {
      closeModal();
    },
    onOk: additionalOptions => {
      deleteFiles(additionalOptions);
    },
    onAfterClose
  };
};
//# sourceMappingURL=getDeleteModalOptions.js.map